module.exports = __webpack_public_path__ + "img/u18-unknown-card.2e51e56d.svg";